module.exports = __webpack_public_path__ + "static/media/footer-school.eaba5240.png";